export interface Api {
  id: string;
  slug: string;
  name: string;
  apiSlug?: string;
  apiName?: string;
  isPrivate: boolean;
  isPublished: boolean;
  isDefault?: boolean;
  url?: string;
  registryUrl?: string;
  projectId?: string;
  project?: string;
  type: 'api' | 'version';
  versions?: Array<Api>
}

export type ApiTypes = 'openapi' | 'asyncapi' | 'invalid'

export interface SHUBApiDetails {
  orgName?: string,
  version?: string,
  name?: string
}

export enum RoutingOption {
  BROWSER = 'browser',
  PROXY = 'proxy',
}

export interface RoutingSettings {
  routing: RoutingOption;
  credentialsEnabled: boolean;
}

export enum APIRenderers {
  ASYNCAPI = 'ASYNCAPI',
  ELEMENTS = 'ELEMENTS',
  SWAGGER_UI = 'SWAGGER_UI'
}

export enum OpenAPIRendererState {
  SWAGGER_UI = APIRenderers.SWAGGER_UI,
  ELEMENTS = APIRenderers.ELEMENTS,
  TOGGLE = 'TOGGLE',
}